import { SpaceBetween } from "@cloudscape-design/components-themed";
import Header from "../components/holdings/Header";
import SearchBar from "../components/holdings/SearchBar";
import Table from "../components/holdings/Table";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

const Holdings = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.HD);

  return (
    <SpaceBetween size="l">
      <Header />
      <SearchBar />
      <Table />
    </SpaceBetween>
  );
};

export default Holdings;
